import { COMMON_OFFERS } from '@sravni/ugc/lib/specialOffers/lists';
import type { OFFERS_TYPE } from '@sravni/ugc/lib/specialOffers/types';

import { getProductData } from '../helpers/getProductData';
import { getProductLinks } from '../helpers/getProductsLink';
import type { IOffer } from '../interfaces/offers';
import { useProductsRating } from '../store/hooks/ratings';

import { useAnalyticsParams } from './useAnalyticsParams';

const EXCEPT_NAMES = [
  {
    name: 'Московский Кредитный Банк',
    shortName: 'МКБ',
  },
  {
    name: 'Азиатско-Тихоокеанский Банк',
    shortName: 'АТБ',
  },
];

export interface Condition {
  value: string | JSX.Element;
  description: string | JSX.Element;
  wide?: boolean;
}

export const useProductData = ({ type, item, organization }: { type: OFFERS_TYPE; item: IOffer; organization }) => {
  const analyticsParams = useAnalyticsParams();
  const productRating = useProductsRating(item.id);
  const productInfo = getProductData(type);

  if (!item || !productInfo) return null;

  const organizationName = organization?.name;
  const exceptName = EXCEPT_NAMES.find((elem) => elem.name === organizationName);
  const bankName = exceptName ? exceptName.shortName : organizationName;

  const isCard = type === COMMON_OFFERS.creditCards || type === COMMON_OFFERS.debitCards;

  const tag = item.bonus;

  const conditionsFunction = productInfo?.getConditions;
  const conditions = conditionsFunction(item)?.filter(Boolean) ?? [];

  const advertisingInfo = item.ad || item.advertising;
  const advertisingAction =
    advertisingInfo?.monetization?.kind === 'referral' ? 'Платный клик' : 'Переход к оформлению заявки';
  const advertisingValue = advertisingInfo?.cost;
  const noticeAboutAdvertisement = `реклама ${organization?.fullName || organizationName}`;
  const advertisingCategory = item.name;
  const advertisingLabel = `${organizationName}|${productInfo?.advertisingCategory}|Ссылка под отзывом`;

  let logoSrc = '';
  if (isCard) {
    logoSrc = item.productLogo;
  } else {
    logoSrc = organization?.squareLogo;
  }

  const clickBlockEvent = {
    eventCategory: advertisingCategory,
    eventAction: advertisingAction,
    eventLabel: advertisingLabel,
    eventValue: advertisingValue,
  };

  const viewBlockEvent = {
    eventAction: 'Показ',
    eventCategory: advertisingCategory,
    eventLabel: advertisingLabel,
  };

  const utmParams = {
    ...analyticsParams,
    aff_sub4: `${advertisingLabel}|${organization._id ?? organization.id}|${item._id}`,
    aff_sub5: advertisingCategory,
  };

  const { viewUrl, clickUrl } = getProductLinks({
    item,
    type,
    utmParams,
    organization,
  });

  return {
    bankName,
    logoSrc,
    isCard,
    offerTitle: item.name,
    ratingValue: productRating?.rating,
    conditions,
    isPartnerCard: organization?.partnerCard,
    noticeAboutAdvertisement,
    tag,
    label: productInfo?.label,
    buttonLabel: type === COMMON_OFFERS.loan || type === COMMON_OFFERS.mortgage ? 'Перейти на сайт' : 'Подробнее',
    clickBlockEvent,
    viewBlockEvent,
    clickUrl,
    viewUrl,
  };
};
